// import { RespCode } from '@constants';
import { logError } from '@log';
import { request } from './request';
// import { MOCK_SUBMIT_RESP } from './mock';

/**
 * 提交理赔申请
 * @param {*} body body
 */
export const submitClaim = async (body) => {
  // console.log('submit-claim-request', body);
  // const resp = MOCK_SUBMIT_RESP;
  try {
    const resp = await request('submit-claim', { body });
    if (!resp) {
      logError(new Error('submit-claim no resp'));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};

export const updateTracking = async (claimId, values) => {
  try {
    const resp = await request('update-tracking', {
      body: {
        claimId,
        ...values,
      },
    });
    if (!resp) {
      logError(new Error('update-tracking no resp'));
      return null;
    }
    return resp;
  } catch (e) {
    logError(e);
    return null;
  }
};
